import React, { Component } from 'react';
import TelehealthType from './TelehealthType';
import PatientInformation from './PatientInformation';
import TelehealthRealTimeDetails from './TelehealthRealTimeDetails';

import { connect } from 'react-redux';
import { alertActions } from '../../../_actions/alert.actions';
import { telehealthService } from '../../../_services/telehealth.service';
import httpStatus from 'http-status';

class TelehealthSchedule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      chartId: "",
      otherId: "",
      groupId: "",
      lastName: "",
      firstName: "",
      providerId: "",
      availableOn: "",
      dateOfBirth: "",
      currentStep: 'PATIENT_INFORMATION',
      telehealthType: "",
      cellPhoneNumber: "",
      appointmentDate: "",
      preVisitQuestionId: "",
      isSaving: false
    }

    this.handleSetState = this.handleSetState.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleBackStep = this.handleBackStep.bind(this);
    this.scheduleTelehealth = this.scheduleTelehealth.bind(this);
  }

  handleSetState(name, value) {
    this.setState({ [name]: value })
  }

  handleNextStep() {
    let nextStep;

    switch (this.state.currentStep) {
      case 'PATIENT_INFORMATION':
        nextStep = 'TELEHEALTH_TYPE';
        break;
      default:
        return false;
    }

    this.setState({ currentStep: nextStep });
  }

  handleBackStep() {
    let nextStep;

    switch (this.state.currentStep) {
      case 'TELEHEALTH_TYPE':
        nextStep = 'PATIENT_INFORMATION';
        break;
      case 'TELEHEALTH_REAL_TIME_DETAILS':
      case 'TELEHEALTH_ASYNCHRONOUS_DETAILS':
        nextStep = 'TELEHEALTH_TYPE';
        break;
      default:
        return false;
    }

    this.setState({ currentStep: nextStep });
  }

  scheduleTelehealth() {
    this.setState({ isSaving: true })

    telehealthService.schedule(this.state)
      .then(() => {
        this.setState({ isSaving: false });

        this.props.history.push('/telehealth');
        this.props.dispatch(alertActions.success('The telehealth appointment has been scheduled!'));
      })
      .catch(error => {
        this.setState({ isSaving: false });

        if (error.response && error.response.status === httpStatus.FORBIDDEN ) {
          this.props.dispatch(alertActions.error("You don't have permission to perform this action."));
        } else {
          this.props.dispatch(alertActions.error('Could not schedule the telehealth appointment at this time. Please try again later.'));
        }
      });
  }

  render() {
    const { currentStep } = this.state;

    return (
      <div className="row">
        <div className="col-lg-12">
          <PatientInformation
            nextStep={this.handleNextStep}
            setValue={this.handleSetState}
            currentStep={currentStep}
            email={this.state.email}
            chartId={this.state.chartId}
            otherId={this.state.otherId}
            lastName={this.state.lastName}
            firstName={this.state.firstName}
            dateOfBirth={this.state.dateOfBirth}
            cellPhoneNumber={this.state.cellPhoneNumber}
          />
        </div>

        <div className="col-lg-12">
          <TelehealthType
            nextStep={this.handleNextStep}
            backStep={this.handleBackStep}
            setValue={this.handleSetState}
            currentStep={currentStep}
          />
        </div>

        <div className="col-lg-12">
          <TelehealthRealTimeDetails
            isSaving={this.state.isSaving}
            nextStep={this.handleNextStep}
            backStep={this.handleBackStep}
            setValue={this.handleSetState}
            saveTelehealth={this.scheduleTelehealth}
            currentStep={currentStep}
            groupId={this.state.groupId}
            providerId={this.state.providerId}
            availableOn={this.state.availableOn}
            appointmentDate={this.state.appointmentDate}
            preVisitQuestionId={this.state.preVisitQuestionId}
            telehealthType={this.state.telehealthType}
            scheduleTelehealth={this.scheduleTelehealth}
          />
        </div>

        {/* <div className="col-lg-12">
                    <TelehealthAsynchronousDetails 
                        isSaving={ this.state.isSaving }
                        nextStep={ this.handleNextStep } 
                        backStep={ this.handleBackStep } 
                        setValue={ this.handleSetState } 
                        saveTelehealth={ this.scheduleTelehealth }
                        currentStep={currentStep} 
                        groupId={this.state.groupId}
                        providerId={this.state.providerId}
                        availableOn={this.state.availableOn}
                        appointmentDate={this.state.appointmentDate}
                        preVisitQuestionId={this.state.preVisitQuestionId}
                        telehealthType={this.state.telehealthType}
                        scheduleTelehealth={ this.scheduleTelehealth }
                    />
                </div> */}
      </div>
    )
  }
}

export default connect()(TelehealthSchedule);